import { render, staticRenderFns } from "./ScreenIndicator.vue?vue&type=template&id=c8de54ec"
import script from "./ScreenIndicator.vue?vue&type=script&lang=js"
export * from "./ScreenIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports